import {
  createRouter,
  createWebHashHistory
} from 'vue-router'
// 生码页面
import RowCode from '../views/RowCode'
// 溯源码库
import Code from '../views/RowCode/code'
// 统计首页
import statistics from '../views/statistics'

import CompanyInfromation from '../views/CompanyInfromation'
// 溯源字段设定
import AssignList from '../views/AssignList'
// 溯源信息设定
import filedList from '../views/filedList'
// 产品
import product from '../views/product'
// 产品自定义字段
import productCustom from '../views/productCustom'
// 查询导语-所有客户
import ResultList from '../views/ResultList'
// 查询导语
import ResultAll from '../views/ResultAll'
// 查询记录
import ScanRecord from '../views/ScanRecord'
// 修改密码
import password from '../views/setting/password'
// 高德信息
import gaode from '../views/setting/gaode'
// 微信公众号
import wxGzh from '../views/setting/wxGzh'
import feedback from '../views/feedBack'
// 经销商
import dealer from '../views/dealer'


// 首页
import login from '../components/login'
import home from '../components/home'
import conter from '../components/toContent'
import user from '../components/toUser'
import setting from '../components/toSetting'
import logistics from '../components/toLogistics'
// import dispense from '../components/toDispense'

// 手机端入库
import mobile from '../components/mobile'

// 出货
import deliveryList from '../views/deliveryList'
// 入货
import storaList from '../views/storaList'
// 退货
import salesReturn from '../views/salesReturn'
// 仓库
import stora from '../views/stora'
// 仓库人员
import storaUser from '../views/storaUser'
// 标签分发
import dispense from '../views/dispense'
// 统计
import dispensestics from '../views/dispensestics'

const routes = [{
  path: '/',
  redirect: '/content/statistics'
},
{
  path: '/home',
  name: 'home',
  component: home,
  children: [
    {
      path: "/content",
      name: 'conter',
      component: conter,
      children: [
        {
          path: '/content/statistics',
          name: 'statistics',
          component: statistics
        },
        {
          path: '/content/product',
          name: 'product',
          component: product
        },
        {
          path: '/content/productCustom',
          name: 'productCustom',
          component: productCustom
        },
        {
          path: '/content/RowCode',
          name: 'RowCode',
          component: RowCode
        },
        {
          path: '/content/CompanyInfromation',
          name: 'CompanyInfromation',
          component: CompanyInfromation
        },
        {
          path: '/content/AssignList',
          name: 'AssignList',
          component: AssignList
        },
        {
          path: '/content/filedList',
          name: 'filedList',
          component: filedList
        },
        {
          path: '/content/ResultAll',
          name: 'ResultAll',
          component: ResultAll
        },
        {
          path: '/content/ResultList',
          name: 'ResultList',
          component: ResultList
        },
        {
          path: '/content/Code',
          name: 'Code',
          component: Code
        },
        {
          path: '/content/ScanRecord',
          name: 'ScanRecord',
          component: ScanRecord
        },
        {
          path: '/content/feedback',
          name: 'feedback',
          component: feedback
        }
      ]
    },
    {
      path: "/user",
      name: 'user',
      component: user,
    },
    {
      path: "/setting",
      name: 'setting',
      component: setting,
      children: [
        {
          path: '/setting/password',
          name: 'password',
          component: password
        },
        {
          path: '/setting/gaode',
          name: 'gaode',
          component: gaode
        },
        {
          path: '/setting/wxGzh',
          name: 'wxGzh',
          component: wxGzh
        },
      ]
    },
    {
      path: "/logistics",
      name: 'logistics',
      component: logistics,
      children: [
        {
          path: '/logistics/dispense',
          name: 'dispense',
          component: dispense
        },
        {
          path: '/logistics/dispensestics',
          name: 'dispensestics',
          component: dispensestics
        },
        {
          path: '/logistics/dealer',
          name: 'dealer',
          component: dealer
        },
        {
          path: '/logistics/storaList',
          name: 'storaList',
          component: storaList
        },
        {
          path: '/logistics/deliveryList',
          name: 'deliveryList',
          component: deliveryList
        },
        {
          path: '/logistics/salesReturn',
          name: 'salesReturn',
          component: salesReturn
        },
        {
          path: '/logistics/stora',
          name: 'stora',
          component: stora
        },
        {
          path: '/logistics/storaUser',
          name: 'storaUser',
          component: storaUser
        },
      ]
    }
  ]
},
{
  path: '/login',
  name: 'login',
  component: login
},
{
  path: '/mobile',
  name: 'mobile',
  component: mobile
},
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
router.beforeEach((to, from, next) => {
  // console.log(to);
  // console.log(from);
  next()
})

export default router